/*
 * @Author: cc
 * @Date: 2020-01-07 18:19:19
 * @LastEditTime: 2021-04-13 15:50:09
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\editPageButton\editPageButton.js
 * @Description: 编辑页面通用底部按钮部分
 */
angular.module('editPageButtonModule', []).directive('editPageButton', [
    '$state',
    'initAppRequiredBtnService',
    'initeditctrBtnsService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'messagePublishService',
    'modalDialog',
    'appParamsService',
    'newMediaService',
    'editingCenterAppService',
    'appConst',
    'editIsLock',
    function(
        $state,
        initAppRequiredBtnService,
        initeditctrBtnsService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        messagePublishService,
        modalDialog,
        appParamsService,
        newMediaService,
        editingCenterAppService,
        appConst,
        editIsLock
    ) {
        return {
            scope: {
                doSave: '&', // 保存方法 决定将保存方法暂定在对应控制器中
                trench: '@', // 渠道类型
            },
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageButton/editPageButton.html',
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {
                        arrayBtn: [],
                        trench: $scope.trench,
                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
                    // 根据不同平台调用不同权限方法
                    $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
                    initeditctrBtnsService
                        .initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform])
                        .then(function(data) {
                            // 按钮
                            $scope.data.dictionaryBtn = [
                                appDictionaryBtnService.initAppCompBtn(),
                                appDictionaryBtnService.initAppPendBtn(),
                                appDictionaryBtnService.initAppSignBtn(),
                            ];
                            initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                                $scope.status.btnStatus = btns;
                                $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                            });
                        });
                }

                /**
                 * [handleBtnClick description]
                 * @param   {[type]}  funname  [funname description]
                 * @return  {[type]}           [return description]
                 */
                $scope.handleBtnClick = function(funname) {
                    eval('$scope.' + funname + '()');
                };

                /**
                 * [save description] 保存方法 (通用)
                 * @return  {[type]}  [return description]
                 */
                $scope.save = function() {
                    $scope.doSave().then((data) => {
                        eval('storageListenerService.addListenerTo' + $scope.trench + "('save')");
                        modalDialog.saveModel('保存成功', '', 'success');
                    });
                };

                /**
                 * [appTrial description] app送审
                 * @return  {[type]}  [return description]
                 */
                $scope.appTrial = function () {
                    newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                        $scope.doSave().then(function () {
                            let trialParams = angular.extend({
                                MetaDataIds: $scope.list.METADATAID,
                                ChnlDocIds: $scope.list.CHNLDOCID,
                                ChannelId: $state.params.appchannelid,
                                Opinion: opinion,
                            }, appConst.params.trialParams);
                            messagePublishService.publish('doEditPageOperation', trialParams);
                        });
                    });
                    
                    // $scope.doSave().then((data) => {
                    //     appParamsService
                    //         .dealParams({
                    //             methodName: appConst.params.trial,
                    //         })
                    //         .then((params) => {
                    //             newMediaService.trial(params, 'App');
                    //         });
                    // });
                };

                /**
                 * [preview description]稿件预览
                 * @return {[type]} [description]
                 */
                $scope.appPreview = function() {
                    $scope.doSave().then(function() {
                        $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                            function() {},
                            function() {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            }
                        );
                    });
                };

                /**
                 * [appSavePublish  保存并发布]
                 * @return {[type]} [description]
                 */
                $scope.appSavePublish = function() {
                    // appParamsService
                    //     .dealParams({
                    //         methodName: appConst.params.publish[$state.params.appplatform],
                    //         ObjectIds: $scope.list.CHNLDOCID,
                    //     })
                    //     .then((params) => {
                    //         newMediaService.publish(params, 'App');
                    //     });
                    $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                        $scope.doSave().then(() => {
                            appParamsService.dealParams({
                                methodName: appConst.params.sign[$state.params.appplatform], // 签发需要区分待编、待审
                            }).then((params) => {
                                messagePublishService.publish('doEditPageOperation', params);
                            });
                        });
                    });
                };

                /**
                 * [appRevoke description] 撤稿操作
                 * @return  {[type]}  [return description]
                 */
                $scope.appRevoke = function() {
                    newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                        $scope.doSave().then(function () {
                            let trialParams = angular.extend({
                                MetaDataIds: $scope.list.METADATAID,
                                ChnlDocIds: $scope.list.CHNLDOCID,
                                ChannelId: $state.params.appchannelid,
                                Opinion: opinion,
                            }, appConst.params.rejectionParams);
                            messagePublishService.publish('doEditPageOperation', trialParams);
                        });
                    });
                    // $scope.doSave().then(
                    //     appParamsService
                    //         .dealParams({
                    //             methodName: appConst.params.rejection,
                    //         })
                    //         .then((params) => {
                    //             newMediaService.rejection(params, 'App');
                    //         })
                    // );
                };

                /**
                 * [trial description 稿件送审]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.appTrial = function() {
                    $scope.doSave().then(() => {
                        appParamsService
                            .dealParams({
                                methodName: appConst.params.trial,
                            })
                            .then((params) => {
                                newMediaService.trial(params, 'App');
                            });
                    });
                };

                /**
                 * [directlyIssued 直接签发]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.appSignDirect = function() {
                    // $scope.doSave().then(function() {
                    //     appParamsService
                    //         .dealParams({
                    //             methodName: appConst.params.sign[$state.params.appplatform], // 签发需要区分待编、待审
                    //         })
                    //         .then((params) => {
                    //             newMediaService.sign(params, 'App');
                    //         });
                    // });
                    $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                        $scope.doSave().then(() => {
                            appParamsService.dealParams({
                                methodName: appConst.params.sign[$state.params.appplatform], // 签发需要区分待编、待审
                            }).then((params) => {
                                messagePublishService.publish('doEditPageOperation', params);
                            });
                        });
                    });
                };

                /**
                 * [appSignTiming 定时签发]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.appSignTiming = function() {
                    $scope.doSave(false).then(function() {
                        appParamsService
                            .dealParams({
                                selectedArray: [$scope.list],
                                isNewDraft: true,
                                methodName: appConst.params.timeSign[$state.params.appplatform], // 签发需要区分待编、待审
                            })
                            .then((params) => {
                                newMediaService.timeSign(params, 'App');
                            });
                    });
                };
            },
        };
    },
]);
